import React, {useEffect} from 'react';
import '../../css/gardenManagerStylings/GardenManagerPastEventsPopupStyling.css';

const GardenManagerPastEventsPopup = ({ selectedGarden }) => { // Changed from gardenId to selectedGarden
    const [allActivities, setAllActivities] = React.useState([]);
    const [recentActivity, setRecentActivity] = React.useState([]);

    // Fetch all activities once on mount
    useEffect(() => {
        const fetchRecentActivities = async () => {
            try {
                // Changed to use the same endpoint as working component
                const activityResponse = await fetch('/api/activities/fetchRecentActivities');
                const activityResult = await activityResponse.json();

                // Check the HTTP response status
                if (!activityResponse.ok) {
                    console.error('Failed to fetch recent activity:', activityResult.error);
                    return;
                }

                // Check if the API returned success: true
                if (!activityResult.success) {
                    console.error('API returned error:', activityResult.error);
                    return;
                }

                setAllActivities(activityResult.data);

            } catch (error) {
                console.error('Fetch error:', error);
            }
        }

        fetchRecentActivities();
    }, []); // Only run once on mount

    useEffect(() => {
        if (!selectedGarden || !selectedGarden.id) { // Changed to check selectedGarden.id
            setRecentActivity([]);
            return;
        }

        // Fixed filtering logic to match how activities are stored
        const thinnedRecentEvents = allActivities.filter(activity => {
            // Direct garden activities
            if (activity.subject === 'garden' && activity.subject_id === selectedGarden.id) {
                return true;
            }

            // Plant activities that belong to this garden
            if (activity.subject === 'plant' && selectedGarden.plants) {
                const plantIds = selectedGarden.plants.map(plant => plant.id);
                return plantIds.includes(activity.subject_id);
            }

            // Fallback: check if garden_id field exists and matches (for backward compatibility)
            if (activity.garden_id !== null && activity.garden_id === selectedGarden.id) {
                return true;
            }

            return false;
        });

        setRecentActivity(thinnedRecentEvents);
    }, [selectedGarden, allActivities]); // Changed gardenId to selectedGarden

    // Add debug logging
    useEffect(() => {
        console.log('Selected Garden:', selectedGarden);
        console.log('All Activities:', allActivities);
        console.log('Filtered Activities:', recentActivity);
    }, [selectedGarden, allActivities, recentActivity]);

    return (
        <div className={`garden-manager-past-events-body`}>
            {recentActivity.length > 0 ? (
                recentActivity.map((activity, index) => (
                    <div className="past-event-card" datatype={activity.event_type?.toLowerCase()} key={activity.id || index}>
                        <div className={`past-event-action`}>
                            {activity.event_type?.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                        </div>
                        <div className={`past-event-date-time`}>
                            {new Date(activity.created_at).toLocaleString()}
                        </div>
                        <div className={`past-event-notes`}>
                            {activity.event_details?.notes || activity.notes}
                        </div>
                    </div>
                ))
            ) : (
                <p>No past events found for this garden</p>
            )}
        </div>
    )
}

export default GardenManagerPastEventsPopup;